<template>
  <b-container fluid class="px-2">
    <b-row v-if="stock_context_loaded">
      <b-col class="mb-4" v-for="(obj, i) in StockInfoObject" :key="'obj-' + i" xl="3" lg="6" md="12">
        <a :href="obj.url" target="_blank">
          <card :info="obj.info" :title="obj.title">
            <div slot="image" :class="obj.bg + ' img-box'">
              <img :src="require(`@/assets/${obj.img}`)" alt="img">
            </div>
          </card>
        </a>
      </b-col>
    </b-row>
    <loader-box v-else height="90px" class="px-2 pb-4 m-0"/>

    <b-row v-if="stock_context_loaded">
      <b-col lg="6" md="12" class="pb-4">
        <div class="white-box px-3">
          <b-row class="table-header">
            <b-col style="text-align: center;">skus em estoque mínimo (até {{ stock_max_limit }})</b-col>
          </b-row>
          <b-row class="m-0 overflow-auto">
            <b-table
              class="text-base text-12"
              style="color: #666666; text-align-last: left;"
              :items="minimum_stock_sku_products"
              :fields="minimumStockSkuFields"
              @row-dblclicked="onRowDoubleClicked"
              head-variant="light" striped hover
            />
          </b-row>
        </div>
      </b-col>
      <b-col lg="6" md="12" class=" pb-4">
        <div class="white-box px-3">
          <b-row class="table-header">
            <b-col style="text-align: center;">skus sem estoque (até {{ stock_max_limit }})</b-col>
          </b-row>
          <b-row class="m-0 overflow-auto">
            <b-table
              class="text-base text-12"
              style="color: #666666; text-align-last: left;"
              :items="no_stock_sku_products"
              :fields="noStockSkuFields"
              @row-dblclicked="onRowDoubleClicked"
              head-variant="light" striped hover
            />
          </b-row>
        </div>
      </b-col>
      <b-col>
        <info-icon  style="top: -15px; position: relative; margin: 0" info="Duplo clique para seguir o link para o produto"></info-icon>
      </b-col>
    </b-row>
    <loader-box v-else height="975px" class="px-2 pb-4 m-0"/>
  </b-container>
</template>

<script>
import Card from '@/components/Card.vue'
import LoaderBox from '@/components/LoaderBox.vue'
import InfoIcon from '@/components/InfoIcon.vue'

export default {
  components: {
    Card,
    LoaderBox,
    InfoIcon
  },
  data: () => ({
    input: null,
    minimumStockSkuFields: [{
      key: 'nome',
      label: 'produto'
    }, {
      key: 'estoque',
      label: 'estoque'
    }, {
      key: 'sku',
      label: 'sku'
    }],
    noStockSkuFields: [{
      key: 'nome',
      label: 'produto'
    }, {
      key: 'sku',
      label: 'sku'
    }]
  }),
  computed: {
    stock_context_loaded() { return this.$store.getters.stock_context_loaded },
    StockInfoObject() { return this.$store.getters.StockInfoObject },
    minimum_stock_sku_products() { return this.$store.getters.minimum_stock_sku_products },
    no_stock_sku_products() { return this.$store.getters.no_stock_sku_products },
    stock_max_limit() { return this.$store.getters.stock_max_limit }
  },
  methods: {
    onRowDoubleClicked(item) {
      // No momento não consegui por um reverse aqui tbm
      window.open(this.$store.getters.baseUrl + '/shoppub/produtos/produto/?q=' + item.sku, '_blank');
    },
  }
}
</script>

<style>
  .table-header {
    align-items: center;
    justify-content: center;
    height: 50px;
  }
</style>
